/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import { Button, Card, CardBody, CardFooter, CardTitle, Col, Collapse, Container, Nav, NavItem, NavLink, Row, } from "reactstrap";
import InventoryDataService from "../../services/InventoryDataService";

class StockReportHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      isOpen: true,
    }
    this.inventoryDataService = new InventoryDataService();
    this.toggleCollapse = this.toggleCollapse.bind(this); // Bind the method
  }

  componentDidMount() {
    this.inventoryDataService.getAlertedProductStocks()
      .then((res) => {
        this.setState({
          products: res.data,
        })
      })
  }

  toggleCollapse = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    return (
      <>
        <div className="header bg-gradient-success pb-8 pt-5 pt-md-8">
          <Container fluid>
            <div className="header-body mx-3 mb-3">
              <Row>
                <Col lg="12" xl="12">
                  <div className="ml-n3 d-flex align-items-center">
                    <Button
                      color="primary"
                      href="#pablo"
                      onClick={() => this.toggleCollapse()}
                      size="sm"
                    >
                      <i className="fas fa-caret-down" />
                    </Button>
                    <h3 className="mb-0">Produk Dibawah Minimal Stok</h3>
                  </div>
                </Col>
                {this.state.products?.map((product, index) => (
                  <Col lg="2" xl="2" className="mt-4">
                    <Collapse isOpen={this.state.isOpen}>
                      <Card className="card-stats mb-4 mb-xl-0 ml-n3" style={{ minHeight: '130px' }}>
                        <CardBody>
                          <Row>
                            <div className="col">
                              <CardTitle tag="h5" className="text-muted mb-0">
                                {product.warehouse_name}
                              </CardTitle>
                              <span
                                className="d-flex flex-column justify-content-between"
                                style={{ minHeight: '60px' }}
                              >
                                <b>{product.product_name}</b>
                                <span style={{ fontSize: '14px', color: 'red' }}>
                                  Sisa stok: {product.stock}
                                </span>
                              </span>
                            </div>
                          </Row>
                        </CardBody>
                      </Card>
                    </Collapse>
                  </Col>
                ))}
              </Row>
            </div>
          </Container>
        </div>
      </>
    );
  }
}

export default StockReportHeader;
